export default __webpack_public_path__ + "static/media/loading.5348a247.svg";